class CartDrawer extends HTMLElement {
  constructor() {
  super();

  this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));

  this.minimumOrder = 4000; // £40.00

  this.minimumOrderObserver = new MutationObserver(() => {
    this.updateMinimumOrder();
  });

  this.minimumOrderObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

  this.setHeaderCartIconAccessibility();

  this.updateMinimumOrder();
}

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
    this.updateMinimumOrder();
  }

    updateMinimumOrder() {

    if (this.minimumOrderUpdating) return;
    this.minimumOrderUpdating = true;

    const checkoutButton = document.querySelector('.candyrack-slider-cart-footer-checkout-button');

    if (!checkoutButton) {
      this.minimumOrderUpdating = false;
      return;
    }

    fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Unable to retrieve cart.');
        }

        return response.json();
      })
      .then((cart) => {
        const minimumOrder = this.minimumOrder;

let message = document.querySelector('#CandyRack-MinimumOrderMessage');

if (!message) {
  const checkoutButton = document.querySelector('.candyrack-slider-cart-footer-checkout-button');

  if (checkoutButton) {
    message = document.createElement('div');
    message.id = 'CandyRack-MinimumOrderMessage';
    message.setAttribute('role', 'alert');
    message.setAttribute('aria-live', 'polite');

    message.innerHTML = `
  <strong>Minimum order £40</strong>
  <span class="minimum-order-text"></span>
`;

    const footerButtons = checkoutButton.closest('.candyrack-slider-cart-footer-buttons-wrapper');

    if (footerButtons) {
      footerButtons.parentNode.insertBefore(message, footerButtons);
    }
  }
}

        if (cart.total_price < minimumOrder) {
          const amountRemaining = minimumOrder - cart.total_price;

          checkoutButton.disabled = true;
          checkoutButton.classList.add('minimum-order-disabled');
          checkoutButton.setAttribute('aria-disabled', 'true');

          if (message) {
  message.style.display = 'block';

  const text = message.querySelector('.minimum-order-text');

  if (text) {
    const formattedAmount = (amountRemaining / 100).toLocaleString('en-GB', {
  style: 'currency',
  currency: 'GBP',
});

text.innerHTML =
  'Please add <strong class="minimum-order-amount">' +
  formattedAmount +
  '</strong> more to your cart to proceed to checkout.';
  }
}
        } else {
          checkoutButton.disabled = false;
          checkoutButton.classList.remove('minimum-order-disabled');
          checkoutButton.removeAttribute('aria-disabled');

          if (message) {
  message.style.display = 'none';
}
        }
      })
            .catch((error) => {
        console.error('Minimum order check failed:', error);
      })
      .finally(() => {
        this.minimumOrderUpdating = false;
      });
  }
  
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
  this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
  this.open();
  this.updateMinimumOrder();
});
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
